import {MenuItem} from '@models/sidebar/menu-item';
import {MenuItemParentDetails} from '@models/elasticSearch/menu/menu-item-parent-details';

export class ElasticMenuItem extends MenuItem {
  parentMenuItem: MenuItemParentDetails = new MenuItemParentDetails();
}
